
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"28","height":"28","viewBox":"0 0 28 28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.5 26.5417H10.5C4.16501 26.5417 1.45834 23.835 1.45834 17.5V10.5C1.45834 4.165 4.16501 1.45833 10.5 1.45833H17.5C23.835 1.45833 26.5417 4.165 26.5417 10.5V17.5C26.5417 23.835 23.835 26.5417 17.5 26.5417ZM10.5 3.20833C5.12168 3.20833 3.20834 5.12167 3.20834 10.5V17.5C3.20834 22.8783 5.12168 24.7917 10.5 24.7917H17.5C22.8783 24.7917 24.7917 22.8783 24.7917 17.5V10.5C24.7917 5.12167 22.8783 3.20833 17.5 3.20833H10.5Z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M12.5533 19.0983C12.0633 19.0983 11.6083 18.9817 11.2 18.7483C10.2667 18.2117 9.73001 17.115 9.73001 15.7267V12.2733C9.73001 10.8967 10.2667 9.78833 11.2 9.25167C12.1333 8.715 13.3467 8.79667 14.5483 9.49667L17.5467 11.2233C18.7367 11.9117 19.425 12.9267 19.425 14C19.425 15.0733 18.7367 16.0883 17.5467 16.7767L14.5483 18.5033C13.8717 18.9 13.1833 19.0983 12.5533 19.0983ZM12.565 10.6517C12.3783 10.6517 12.215 10.6867 12.0867 10.7683C11.7133 10.99 11.4917 11.5383 11.4917 12.2733V15.7267C11.4917 16.4617 11.7017 17.01 12.0867 17.2317C12.46 17.4533 13.0433 17.36 13.685 16.9867L16.6833 15.26C17.325 14.8867 17.6867 14.4317 17.6867 14C17.6867 13.5683 17.325 13.1017 16.6833 12.74L13.685 11.0133C13.265 10.7683 12.88 10.6517 12.565 10.6517Z","fill":"currentColor"}})])
          )
        }
      }
    